const SupportIcon = () => {
	return (
		<svg focusable="false" height="20" width="20">
			<g transform="translate(0, 0) scale(1)">
				<path
					d="M0 4c0-1.654 1.346-3 3-3h17v13c0 1.654-1.346 3-3 3H5.17a4.897 4.897 0 00-2.704.831L0 19.512V4zm17 11a1 1 0 001-1V3H3a1 1 0 00-1 1v11.786A6.887 6.887 0 015.165 15H17zM6 12h6v-2H6v2zm8-4H6V6h8v2z"
					fill="rgba(14, 14, 15, 1)"
				></path>
			</g>
		</svg>
	);
};

export default SupportIcon;
